export default class PreviewsComponent {
  static CLASSES = {
    PREVIEWS: 'previews',
    CONTROLS_FILTER: 'previews__controls__filter'
  };

  static init($previews) {
    if (!$previews || $previews.previewsComponent) {
      return;
    }

    $previews.previewsComponent = new PreviewsComponent($previews);
  }

  static initAll() {
    document.querySelectorAll(`.${PreviewsComponent.CLASSES.PREVIEWS}`).forEach(($previews) => {
      PreviewsComponent.init($previews);
    });
  }

  constructor($previews) {
    this.$previews = $previews;
    this.$controlsFilter = $previews.querySelector(`.${PreviewsComponent.CLASSES.CONTROLS_FILTER}`);

    this.onChangeControlsFilter = this.onChangeControlsFilter.bind(this);

    this.init();
  }

  init() {
    if (this.$controlsFilter) {
      this.$controlsFilter.addEventListener('change', this.onChangeControlsFilter);
    }
  }

  destroy() {
    if (this.$controlsFilter) {
      this.$controlsFilter.removeEventListener('change', this.onChangeControlsFilter);
    }

    this.$previews.previewsComponent = null;
  }

  onChangeControlsFilter() {
    this.$controlsFilter.submit();
  }
}
